import "core-js/modules/es6.object.freeze";
import "core-js/modules/es6.object.define-properties";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.define-property";
import _get from "lodash/get";
import _values from "lodash/values";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  fragment BaseMarketplaceStarRating on MarketplaceEntityInterface {\n    ...MarketplaceReviewLink\n  }\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { gql } from '@nerdwallet/apollo';
import { useDeprecatedPropsWarning } from '@nerdwallet/deprecate';
import { colors } from '@nerdwallet/base-styles/variables';
import MarketplaceReviewLink, { GraphQlMarketplaceReviewLink, LINK_TYPES } from '@nerdwallet/react-marketplace-review-link';
import { HelpBubble, StarRating, Type } from '@nerdwallet/currency';
import classes from '@nerdwallet/base-styles/classes';
import Star from './_star';
import styles from './marketplace-star-rating.module.less';
var RATING_TEXT = 'NerdWallet rating';
var NO_RATING_TEXT = 'Not yet rated';
export var LAYOUTS = {
  INLINE: 'inline',
  STACKED: 'stacked',
  BIG_NUMBER: 'big-number',
  NUMERIC: 'numeric',
  SMALL_NUMERIC: 'small_numeric'
};
export var TOOLTIP_TEXT = {
  auto_insurance: "NerdWallet's ratings are determined by our editorial team. The scoring formula takes into account consumer complaint and customer satisfaction data.",
  insurance: "NerdWallet's ratings are determined by our editorial team. The scoring formula takes into account consumer complaint and customer satisfaction data.",
  auto_loans: "NerdWallet's ratings are determined by our editorial team. The scoring formula takes into account factors like maximum rates, variety of loan options, visibility of borrower requirements, accessibility, speed of funding, fees and more.",
  banking: "NerdWallet's ratings are determined by our editorial team. The scoring formulas take into account multiple data points for each financial product and service.",
  credit_cards: "NerdWallet's ratings are determined by our editorial team. The scoring formula takes into account the type of card being reviewed (such as cash back, travel or balance transfer) and the card's rates, fees, rewards and other features.",
  "default": "NerdWallet's ratings are determined by our editorial team. The scoring formulas take into account multiple data points for each financial product and service.",
  education_loans: "NerdWallet's ratings are determined by our editorial team. The scoring formula for student loan products takes into account more than 50 data points across multiple categories, including repayment options, customer service, lender transparency, loan eligibility and underwriting criteria.",
  investing: "NerdWallet's ratings are determined by our editorial team. The scoring formula for online brokers and robo-advisors takes into account over 15 factors, including account fees and minimums, investment choices, customer support and mobile app capabilities.",
  mortgages: "NerdWallet's ratings are determined by our editorial team. The scoring formula takes into account loan types and loan products offered, online conveniences, online mortgage rate information, and the rate spread and origination fee lenders reported in the latest available HMDA data.",
  personal_loans: "NerdWallet's ratings are determined by our editorial team. The scoring formula takes into account factors we consider to be consumer-friendly, including impact to credit score, rates and fees, customer experience and responsible lending practices."
};

var BaseMarketplaceStarRating = function BaseMarketplaceStarRating(_ref) {
  var _classNames;

  var analytics = _ref.analytics,
      enableAnalytics = _ref.enableAnalytics,
      starRating = _ref.starRating,
      hideNumber = _ref.hideNumber,
      hideRatingText = _ref.hideRatingText,
      ratingTextHref = _ref.ratingTextHref,
      omitRatingTextHref = _ref.omitRatingTextHref,
      omitRatingNumberHref = _ref.omitRatingNumberHref,
      ratingTextTooltip = _ref.ratingTextTooltip,
      tooltipPlacement = _ref.tooltipPlacement,
      trkLocation = _ref.trkLocation,
      trkPageType = _ref.trkPageType,
      trkTaxonomy = _ref.trkTaxonomy,
      layout = _ref.layout,
      marketplaceEntity = _ref.marketplaceEntity,
      gqlMarketplaceEntity = _ref.gqlMarketplaceEntity,
      className = _ref.className,
      productType = _ref.productType,
      showNotYetRated = _ref.showNotYetRated,
      smallRatingText = _ref.smallRatingText;
  useDeprecatedPropsWarning({
    component: 'BaseMarketplaceStarRating',
    deprecatedProps: [{
      version: '2.11.0',
      deprecated: 'enableAnalytics',
      migration: 'use analytics instead'
    }],
    props: {
      enableAnalytics: enableAnalytics
    }
  });
  var isLayoutStacked = layout === LAYOUTS.STACKED;
  var isLayoutBigNumber = layout === LAYOUTS.BIG_NUMBER;
  var isLayoutNumeric = layout === LAYOUTS.NUMERIC;
  var isLayoutSmallNumeric = layout === LAYOUTS.SMALL_NUMERIC;
  var tooltipText = ratingTextTooltip || TOOLTIP_TEXT[productType] || TOOLTIP_TEXT["default"];
  var ReviewLinkComponent = gqlMarketplaceEntity ? GraphQlMarketplaceReviewLink : MarketplaceReviewLink;
  var entity = gqlMarketplaceEntity || marketplaceEntity;

  var starComponent = function starComponent(color) {
    return /*#__PURE__*/React.createElement(Star, {
      firstHalfStarFill: colors[color],
      secondHalfStarFill: colors[color]
    });
  };

  var starRatingComponent = function starRatingComponent() {
    var _ref2;

    return /*#__PURE__*/React.createElement(StarRating, {
      nerdwallet: true,
      rating: starRating,
      className: classNames([styles.stars, (_ref2 = {}, _defineProperty(_ref2, styles.layoutStacked, isLayoutStacked), _defineProperty(_ref2, styles.layoutBigNumber, isLayoutBigNumber), _ref2)])
    });
  };

  var maxAnnotationComponent = function maxAnnotationComponent() {
    return /*#__PURE__*/React.createElement(Type, {
      size: 1,
      inline: true,
      light: true,
      className: classNames([styles.ratingNumberMaxAnnotation, classes(['margin-left-1'])])
    }, "/5");
  };

  var ratingNumberComponent = function ratingNumberComponent() {
    var _ref3;

    return /*#__PURE__*/React.createElement(Type, {
      className: classNames([styles.ratingNumber, (_ref3 = {}, _defineProperty(_ref3, styles.layoutStacked, isLayoutStacked), _defineProperty(_ref3, styles.layoutBigNumber, isLayoutBigNumber), _defineProperty(_ref3, styles.accessibleLinkTarget, isLayoutNumeric || isLayoutSmallNumeric), _defineProperty(_ref3, styles.layoutSmallNumeric, isLayoutSmallNumeric), _ref3)])
    }, starRating.toFixed(1));
  };

  var ratingTextComponent = function ratingTextComponent() {
    var _ref4;

    return /*#__PURE__*/React.createElement("span", {
      className: classNames([styles.ratingText, (_ref4 = {}, _defineProperty(_ref4, styles.layoutBigNumber, isLayoutBigNumber), _defineProperty(_ref4, styles.smallRatingText, smallRatingText), _ref4)])
    }, !omitRatingTextHref && ratingTextHref ? /*#__PURE__*/React.createElement(ReviewLinkComponent, {
      href: ratingTextHref,
      marketplaceEntity: entity,
      type: LINK_TYPES.LINK,
      trkLocation: trkLocation,
      trkPageType: trkPageType,
      trkTaxonomy: trkTaxonomy
    }, RATING_TEXT) : RATING_TEXT, tooltipText && /*#__PURE__*/React.createElement(Fragment, null, "\xA0", /*#__PURE__*/React.createElement(HelpBubble, {
      placement: tooltipPlacement,
      content: tooltipText,
      title: "How is this rating determined?",
      analytics: (enableAnalytics || analytics) && _objectSpread({
        entityNamePrefix: 'rating-link-tooltip'
      }, analytics)
    })));
  };

  var renderBigNumberLayout = function renderBigNumberLayout() {
    return /*#__PURE__*/React.createElement("div", {
      className: styles.flexContainer
    }, ratingNumberComponent(), /*#__PURE__*/React.createElement("div", null, ratingTextComponent(), starRatingComponent()));
  };

  var getRatingAriaLabel = function getRatingAriaLabel() {
    return starRating ? "rated ".concat(starRating.toFixed(1), " out of 5") : 'unrated';
  };

  var renderNumericLayout = function renderNumericLayout() {
    if (!starRating && !showNotYetRated) {
      return null;
    }

    var ratingAriaLabel = getRatingAriaLabel();
    var shouldShowNotYetRated = !starRating && showNotYetRated;
    var numericLayoutContent = /*#__PURE__*/React.createElement(Fragment, null, starComponent(shouldShowNotYetRated && 'neutral-lighter'), shouldShowNotYetRated ? /*#__PURE__*/React.createElement(Type, {
      className: styles.noRatingText,
      light: true,
      size: 1
    }, NO_RATING_TEXT) : /*#__PURE__*/React.createElement("span", {
      "aria-label": ratingAriaLabel
    }, ratingNumberComponent(), maxAnnotationComponent()));
    return /*#__PURE__*/React.createElement(Fragment, null, !hideRatingText && ratingTextComponent(), !omitRatingNumberHref && !shouldShowNotYetRated && ratingTextHref ? /*#__PURE__*/React.createElement(ReviewLinkComponent, {
      "aria-label": "Nerdwallet product review; ".concat(ratingAriaLabel),
      className: styles.accessibleLink,
      href: ratingTextHref,
      marketplaceEntity: entity,
      type: LINK_TYPES.LINK,
      trkLocation: trkLocation,
      trkPageType: trkPageType,
      trkTaxonomy: trkTaxonomy
    }, numericLayoutContent) : /*#__PURE__*/React.createElement("span", {
      className: styles.noLinkLayout
    }, numericLayoutContent));
  };

  var renderSmallNumericLayout = function renderSmallNumericLayout() {
    if (!starRating && !showNotYetRated) {
      return null;
    }

    var shouldShowNotYetRated = !starRating && showNotYetRated;
    var numericLayoutContent = /*#__PURE__*/React.createElement(Fragment, null, starComponent(shouldShowNotYetRated && 'neutral-lighter'), shouldShowNotYetRated ? /*#__PURE__*/React.createElement(Type, {
      className: styles.noRatingText,
      light: true,
      size: 1
    }, NO_RATING_TEXT) : /*#__PURE__*/React.createElement("span", {
      "aria-label": getRatingAriaLabel()
    }, ratingNumberComponent(), maxAnnotationComponent()));
    return /*#__PURE__*/React.createElement(Fragment, null, !omitRatingNumberHref && !shouldShowNotYetRated && ratingTextHref ? /*#__PURE__*/React.createElement(ReviewLinkComponent, {
      className: styles.smallNumericLayoutLink,
      href: ratingTextHref,
      marketplaceEntity: entity,
      type: LINK_TYPES.LINK,
      trkLocation: trkLocation,
      trkPageType: trkPageType,
      trkTaxonomy: trkTaxonomy
    }, numericLayoutContent) : /*#__PURE__*/React.createElement("span", {
      className: styles.smallNumericNoLinkLayout
    }, numericLayoutContent));
  };

  var renderContent = function renderContent() {
    if (!starRating && layout !== LAYOUTS.NUMERIC && layout !== LAYOUTS.SMALL_NUMERIC) {
      if (showNotYetRated) {
        return /*#__PURE__*/React.createElement(Fragment, null, starRatingComponent(), /*#__PURE__*/React.createElement(Type, {
          size: 1,
          className: styles.noRatingText
        }, NO_RATING_TEXT));
      }

      return null;
    }

    switch (layout) {
      case LAYOUTS.BIG_NUMBER:
        return renderBigNumberLayout();

      case LAYOUTS.SMALL_NUMERIC:
        return renderSmallNumericLayout();

      case LAYOUTS.NUMERIC:
        return renderNumericLayout();

      default:
        return /*#__PURE__*/React.createElement(Fragment, null, starRatingComponent(), !hideNumber && ratingNumberComponent(), ratingTextComponent());
    }
  };

  return /*#__PURE__*/React.createElement("div", {
    className: classNames(className, (_classNames = {}, _defineProperty(_classNames, styles.layoutNumeric, isLayoutNumeric), _defineProperty(_classNames, styles.layoutSmallNumeric, isLayoutSmallNumeric), _classNames))
  }, renderContent());
};

BaseMarketplaceStarRating.propTypes = {
  /** Optional classes to apply to the outer container. */
  className: PropTypes.string,
  analytics: PropTypes.shape({
    entityName: PropTypes.string
  }),

  /** (Deprecated) A flag enabling analytics */
  enableAnalytics: PropTypes.bool,

  /** Specify alternate layouts from the enum list */
  layout: PropTypes.oneOf(_values(LAYOUTS)),

  /** Href for the rating link. */
  ratingTextHref: PropTypes.string,

  /** If true, the link to the review on the rating text will be omitted. */
  omitRatingTextHref: PropTypes.bool,

  /** If true, the link to the review on the rating number will be omitted. */
  omitRatingNumberHref: PropTypes.bool,

  /** Tooltip for the rating text. */
  ratingTextTooltip: PropTypes.string,

  /** Help bubble tooltip placement */
  tooltipPlacement: PropTypes.oneOf(['top', 'right', 'bottom', 'left']),

  /** Shows not yet rated component with empty star rating */
  showNotYetRated: PropTypes.bool,

  /** Gives both rating text and help bubble a font size of size-1 instead of the default size-2 */
  smallRatingText: PropTypes.bool,

  /** Star rating value. */
  starRating: PropTypes.number,

  /** Hides the numerical rating. */
  hideNumber: PropTypes.bool,

  /** Hides the rating text. */
  hideRatingText: PropTypes.bool,

  /**  Marketplace entity object from marketplace, passed down to review link */
  marketplaceEntity: PropTypes.object,
  // eslint-disable-line react/forbid-prop-types

  /**  Marketplace entity object from graphQl, passed down to review link */
  gqlMarketplaceEntity: PropTypes.shape({
    reviewLink: PropTypes.string,
    starRating: PropTypes.string,
    starRatingTooltip: PropTypes.string
  }),

  /** Tracking location (required if ratingTextHref is specified). */
  trkLocation: PropTypes.string,

  /** Tracking page type (required if ratingTextHref is specified). */
  trkPageType: PropTypes.string,

  /** Tracking taxonomy (required if ratingTextHref is specified). */
  trkTaxonomy: PropTypes.shape({
    /** Taxonomy page type. */
    pageType: PropTypes.string,

    /** Taxonomy topic. */
    topic: PropTypes.string,

    /** Taxonomy vertical. */
    vertical: PropTypes.string
  }),
  productType: PropTypes.string
};
BaseMarketplaceStarRating.defaultProps = {
  analytics: {},
  className: null,
  layout: LAYOUTS.INLINE,
  hideNumber: false,
  hideRatingText: false,
  ratingTextHref: null,
  omitRatingTextHref: false,
  omitRatingNumberHref: true,
  ratingTextTooltip: null,
  tooltipPlacement: 'top',
  showNotYetRated: false,
  smallRatingText: false,
  starRating: 0,
  trkLocation: 'marketplace-star-rating',
  trkPageType: null,
  trkTaxonomy: _get(global.window, 'nwPageTaxonomy'),
  productType: null
};
BaseMarketplaceStarRating.fragment = gql(_templateObject(), GraphQlMarketplaceReviewLink.fragment);
export default BaseMarketplaceStarRating;